import iso31662 from "iso-3166-2";

export interface StateOption {
  /** Bare subdivision code (for example `LIM` from `PE-LIM`). */
  code: string;
  /** Full ISO 3166-2 code (for example `PE-LIM`). */
  fullCode: string;
  name: string;
}

const cache = new Map<string, StateOption[]>();

export const statesForCountry = (
  countryAlpha2: string | undefined | null
): StateOption[] => {
  if (!countryAlpha2) return [];
  const upper = countryAlpha2.toUpperCase();
  const cached = cache.get(upper);
  if (cached) return cached;

  const country = (
    iso31662 as unknown as {
      country: (
        code: string
      ) => { sub?: Record<string, { name: string; type: string }> } | null;
    }
  ).country(upper);

  if (!country?.sub) {
    cache.set(upper, []);
    return [];
  }

  const items = Object.entries(country.sub).map(([fullCode, subdivision]) => ({
    code: fullCode.split("-")[1] ?? fullCode,
    fullCode,
    name: subdivision.name,
  }));
  items.sort((a, b) => a.name.localeCompare(b.name));
  cache.set(upper, items);
  return items;
};
